
import * as type from './types';

export function myWorksNewFolder(data) {
    return {
        type: type.CREATE_MY_WORKS_FOLDER_REQUESTED,
        data: data,
    }
};